module.exports = new __parcel__URL__("voicifyAvatar.c9485f40.svg").toString();